module.exports = __webpack_public_path__ + "assets/img/verslui.d0be4169.jpg";